import axios from 'axios';

/**获取url参数**/
export function getQueryVariable(variable){
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
    }
    return(false);
}

export function getQueryObject(url) {
    url = url == null ? window.location.href : url
    const search = url.substring(url.lastIndexOf('?') + 1)
    const obj = {}
    const reg = /([^?&=]+)=([^?&=]*)/g
    search.replace(reg, (rs, $1, $2) => {
      const name = decodeURIComponent($1)
      let val = decodeURIComponent($2)
      val = String(val)
      obj[name] = val
      return rs
    })
    return obj
}
  

export function formatTarTime(date) {
    const curDate = new Date()
    const curTime = curDate.getTime()
    const tarTime = date.getTime()
    // return curTime > tarTime
    return false
}


/**获取url参数**/
export function getAgent(){
    let userEuip = navigator.userAgent
    let isAndroid = userEuip.indexOf('Android') > -1 || userEuip.indexOf('Adr') > -1
    return(isAndroid);
}


/**防重点击**/
let clickTimer = 0
export function clickThrottle(interval){
    let now = +new Date();
    let timer = clickTimer;

    if(now - timer < interval){
        return false
    }else{
        clickTimer = now;
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/utils/index.js